(ns ncr.etc.pf
  (:require
   [taoensso.encore :as e]
   [uix.core.alpha :as uix]
   [uix.compiler.alpha :as uix.compiler]
   ["react-dom/server" :as react-dom-server]
   [lambdaisland.glogi :as log]
   [camel-snake-kebab.core :as csk]
   [ncr.widgets.util :as wu]
   ["@patternfly/react-core/dist/esm/components/AboutModal" :refer [AboutModal]]
   ["@patternfly/react-core/dist/esm/components/Alert" :refer [Alert AlertActionCloseButton AlertActionLink]]
   ["@patternfly/react-core/dist/esm/components/AlertGroup" :refer [AlertGroup]]
   ["@patternfly/react-core/dist/esm/components/Avatar" :refer [Avatar]]
   ["@patternfly/react-core/dist/esm/components/Backdrop" :refer [Backdrop]]
   ["@patternfly/react-core/dist/esm/components/Badge" :refer [Badge]]
   ["@patternfly/react-core/dist/esm/components/Button" :refer [Button]]
   ["@patternfly/react-core/dist/esm/components/CalendarMonth" :refer [CalendarMonth]]
   ["@patternfly/react-core/dist/esm/components/Card" :refer [Card CardActions CardBody CardExpandableContent CardFooter CardHeader CardHeaderMain CardTitle]]
   ["@patternfly/react-core/dist/esm/components/Checkbox" :refer [Checkbox]]
   ["@patternfly/react-core/dist/esm/components/Chip" :refer [Chip]]
   ["@patternfly/react-core/dist/esm/components/ChipGroup" :refer [ChipGroup]]
   ["@patternfly/react-core/dist/esm/components/ClipboardCopy" :refer [ClipboardCopyButton]]
   ["@patternfly/react-core/dist/esm/components/CodeBlock" :refer [CodeBlock CodeBlockAction CodeBlockCode]]
   ["@patternfly/react-core/dist/esm/components/DataList" :refer [DataList DataListAction DataListCell DataListCheck DataListContent DataListControl DataListItem DataListItemCells DataListItemRow DataListToggle]]
   ["@patternfly/react-core/dist/esm/components/DatePicker" :refer [DatePicker]]
   ["@patternfly/react-core/dist/esm/components/DescriptionList" :refer [DescriptionList DescriptionListDescription DescriptionListGroup DescriptionListTerm]]
   ["@patternfly/react-core/dist/esm/components/Divider" :refer [Divider]]
   ["@patternfly/react-core/dist/esm/components/Drawer" :refer [Drawer DrawerActions DrawerCloseButton DrawerContent DrawerContentBody DrawerHead DrawerPanelBody DrawerPanelContent DrawerSection]]
   ["@patternfly/react-core/dist/esm/components/Dropdown" :refer [Dropdown DropdownGroup DropdownItem DropdownSeparator DropdownToggle DropdownToggleAction DropdownToggleCheckbox KebabToggle]]
   ["@patternfly/react-core/dist/esm/components/EmptyState" :refer [EmptyState EmptyStateBody EmptyStateIcon EmptyStateSecondaryActions]]
   ["@patternfly/react-core/dist/esm/components/ExpandableSection" :refer [ExpandableSection]]
   ["@patternfly/react-core/dist/esm/components/FileUpload" :refer [FileUpload FileUploadField]]
   ["@patternfly/react-core/dist/esm/components/Form" :refer [ActionGroup Form FormGroup FormFieldGroup FormFieldGroupExpandable FormFieldGroupHeader FormFieldGroupToggle FormHelperText]]
   ["@patternfly/react-core/dist/esm/components/FormSelect" :refer [FormSelect FormSelectOption]]
   ["@patternfly/react-core/dist/esm/components/HelperText" :refer [HelperText HelperTextItem]]
   ["@patternfly/react-core/dist/esm/components/InputGroup" :refer [InputGroup InputGroupText]]
   ["@patternfly/react-core/dist/esm/components/Label" :refer [Label]]
   ["@patternfly/react-core/dist/esm/components/LabelGroup" :refer [LabelGroup]]
   ["@patternfly/react-core/dist/esm/components/List" :refer [List ListItem]]
   ["@patternfly/react-core/dist/esm/components/Menu" :refer [Menu MenuContent MenuGroup MenuItem MenuList]]
   ["@patternfly/react-core/dist/esm/components/Modal" :refer [Modal ModalBoxBody ModalTextBody]]
   ["@patternfly/react-core/dist/esm/components/Nav" :refer [Nav NavExpandable NavItem NavList NavItemSeparator]]
   ["@patternfly/react-core/dist/esm/components/NumberInput" :refer [NumberInput]]
   ["@patternfly/react-core/dist/esm/components/Page" :refer [Page PageBreadcrumb PageGroup PageHeader PageHeaderTools PageHeaderToolsGroup PageHeaderToolsItem PageNavigation PageSection PageSidebar PageToggleButton]]
   ["@patternfly/react-core/dist/esm/components/Panel" :refer [Panel PanelFooter PanelHeader PanelMain PanelMainBody]]
   ["@patternfly/react-core/dist/esm/components/Popover" :refer [Popover]]
   ["@patternfly/react-core/dist/esm/components/Progress" :refer [Progress]]
   ["@patternfly/react-core/dist/esm/components/SearchInput" :refer [SearchInput]]
   ["@patternfly/react-core/dist/esm/components/Select" :refer [Select SelectGroup SelectOption]]
   ["@patternfly/react-core/dist/esm/components/Spinner" :refer [Spinner]]
   ["@patternfly/react-core/dist/esm/components/Switch" :refer [Switch]]
   ["@patternfly/react-core/dist/esm/components/Tabs" :refer [Tabs Tab TabTitleIcon TabTitleText]]
   ["@patternfly/react-core/dist/esm/components/Text" :refer [Text TextContent TextList TextListItem]]
   ["@patternfly/react-core/dist/esm/components/TextArea" :refer [TextArea]]
   ["@patternfly/react-core/dist/esm/components/TextInput" :refer [TextInput]]
   ["@patternfly/react-core/dist/esm/components/TextInputGroup" :refer [TextInputGroup TextInputGroupMain TextInputGroupUtilities]]
   ["@patternfly/react-core/dist/esm/components/Title" :refer [Title]]
   ["@patternfly/react-core/dist/esm/components/ToggleGroup" :refer [ToggleGroup ToggleGroupItem]]
   ["@patternfly/react-core/dist/esm/components/Toolbar" :refer [Toolbar ToolbarContent ToolbarFilter ToolbarGroup ToolbarItem ToolbarToggleGroup]]
   ["@patternfly/react-core/dist/esm/components/Tooltip" :refer [Tooltip]]
   ["@patternfly/react-core/dist/esm/components/Truncate" :refer [Truncate]]
   ["@patternfly/react-core/dist/esm/layouts/Bullseye" :refer [Bullseye]]
   ["@patternfly/react-core/dist/esm/layouts/Flex" :refer [Flex FlexItem]]
   ["@patternfly/react-core/dist/esm/layouts/Grid" :refer [Grid GridItem]]
   ["@patternfly/react-core/dist/esm/layouts/Stack" :refer [Stack StackItem]]
   ["@patternfly/react-core/dist/esm/layouts/Split" :refer [Split SplitItem]]
   ["@patternfly/react-icons/dist/esm/icons/bars-icon" :refer [BarsIcon]]
   ["@patternfly/react-icons/dist/esm/icons/search-icon" :refer [SearchIcon]]
   ["@patternfly/react-icons/dist/esm/icons/times-icon" :refer [TimesIcon]]
   ["@patternfly/react-icons/dist/esm/icons/check-icon" :refer [CheckIcon]]
   ["@patternfly/react-icons/dist/esm/icons/info-icon" :refer [InfoIcon]]
   ["@patternfly/react-icons/dist/esm/createIcon" :refer [createIcon]]
   ["react-markdown" :default ReactMarkdown]
   ["remark-gfm" :default remarkGfm]
   ["react-autocomplete-input" :default ReactAutocompleteInput]
   [ncr.etc.pubsub :as ps]))

#_(defn- htag? [in]
    (and
      (vector? in)
      (let [[first & _] in]
        (or
          (keyword? first)
          (fn? first)))))

#_(defn render-to-string [in]
    (if (htag? in)
      (react-dom-server/renderToStaticMarkup
        (uix/as-element in))
      in))

(defn- update? [m key f]
  (if-let [[k v] (find m key)]
    (assoc m k (f v))
    m))

(defn- wrap-props [props]
  (let
    [props
     (-> props
       (update? :class uix.compiler/class-names)
       (update? :style uix.compiler/convert-prop-value))]

    (e/map-vals
      (fn [val]
        (if (wu/hiccup-element? val)
          (uix/as-element val)
          (clj->js val)))
      props)))

(defn- wrap* [^js class [first & rest :as all] preprocess]
  (if (map? first)
    (into
      [:> class
       (wrap-props (preprocess first))] rest)
    (into [:> class] all)))

(defn wrap
  ([class]
   (wrap class identity))
  ([class preprocess]
   (fn [& args]
     (wrap* class args preprocess))))

(def c-list (wrap List))
(def c-list-item (wrap ListItem))

(defn c-tabs* [props children]
  (into [:> ^js Tabs (wrap-props props)]
    (map #(apply (first %) (rest %)) children)))

(defn c-tabs [props & children]
  (c-tabs* props children))

(def c-tab
  (wrap Tab))

(def c-tab-title-text (wrap TabTitleText))
(def c-tab-title-icon (wrap TabTitleIcon))
(def c-button (wrap Button))

(def c-label (wrap Label))
(def c-label-group (wrap LabelGroup))

(def c-data-list (wrap DataList))
(def c-data-list-control (wrap DataListControl))
(def c-data-list-toggle (wrap DataListToggle))
(def c-data-list-check (wrap DataListCheck))
(defn c-data-list-checkbox [{:keys [on-change] :as props}]
  [:div.pf-c-data-list__checkbox
   {:on-click on-change}
   [c-data-list-check
    (assoc props :on-change (fn [_ e] (on-change e)))]])

(def c-data-list-content (wrap DataListContent))
(def c-data-list-cell (wrap DataListCell))

(def c-data-list-item (wrap DataListItem))
(def c-data-list-item-row (wrap DataListItemRow))

(defn c-data-list-item-cells [props & cells]
  [:> ^js DataListItemCells
   (assoc (wrap-props props) :dataListCells
     (map-indexed
       (fn [index cell]
         (uix/as-element
           (with-meta
             cell {:key index}))) cells))])

(def c-data-list-action (wrap DataListAction))

(def c-form (wrap Form))
(def c-form-group (wrap FormGroup))
(def c-action-group (wrap ActionGroup))

(def c-form-field-group (wrap FormFieldGroup))
(def c-form-field-group-raw FormFieldGroup)
(def c-form-field-group-expandable (wrap FormFieldGroupExpandable))
(def c-form-field-group-header (wrap FormFieldGroupHeader))
(def c-form-field-group-toggle (wrap FormFieldGroupToggle))


(def c-stack (wrap Stack))
(def c-stack-item (wrap StackItem))

(defn- with-synthetic-id [^js comp]
  (fn [& [props & _]]
    [:> comp
     (-> (or props {})
       (update :id (fn [id] (or id (uix/memo #(gensym "id") []))))
       wrap-props)]))

(def c-text-input
  (with-synthetic-id TextInput))

(def c-number-input (wrap NumberInput))

(def c-text-area
  (with-synthetic-id TextArea))

(def c-text-input-group (wrap TextInputGroup))
(def c-text-input-group-main (wrap TextInputGroupMain))
(def c-text-input-group-utilities (wrap TextInputGroupUtilities))

(def c-search-input (wrap SearchInput))

(def c-split (wrap Split))
(def c-split-item (wrap SplitItem))

(def c-toolbar (wrap Toolbar))
(def c-toolbar-content (wrap ToolbarContent))
(def c-toolbar-item (wrap ToolbarItem))
(def c-toolbar-filter (wrap ToolbarFilter))
(def c-toolbar-group (wrap ToolbarGroup))

(def c-toolbar-toggle-group (wrap ToolbarToggleGroup))

(def c-toggle-group (wrap ToggleGroup))
(def c-toggle-group-item (wrap ToggleGroupItem))

(def c-page (wrap Page))
(def c-page-header (wrap PageHeader))
(def c-page-header-tools (wrap PageHeaderTools))
(def c-page-header-tools-group (wrap PageHeaderToolsGroup))
(def c-page-header-tools-item (wrap PageHeaderToolsItem))

(def c-page-sidebar (wrap PageSidebar))
(def c-page-section (wrap PageSection))
(def c-page-group (wrap PageGroup))
(def c-page-breadcrumb (wrap PageBreadcrumb))
(def c-page-navigation (wrap PageNavigation))
(def c-page-toggle-button (wrap PageToggleButton))

(def c-nav (wrap Nav))
(def c-nav-list (wrap NavList))
(def c-nav-item (wrap NavItem))
(def c-nav-item-separator (wrap NavItemSeparator))
(def c-nav-expandable (wrap NavExpandable))

(def c-expandable-section (wrap ExpandableSection))
(def c-divider (wrap Divider))

(def c-bullseye (wrap Bullseye))

(def c-empty-state (wrap EmptyState))
(def c-empty-state-body (wrap EmptyStateBody))

(def c-empty-state-icon
  (wrap EmptyStateIcon
    (fn [props]
      (update? props :component
        #(when %
           (uix.compiler/as-react
             (constantly %)))))))

(def c-empty-state-secondary-actions (wrap EmptyStateSecondaryActions))

(def c-spinner (wrap Spinner))
(def c-switch (wrap Switch))
(def c-progress (wrap Progress))

(def c-title
  (wrap Title
    (fn [props]
      (update props :heading-level
        #(or % :h2)))))

(def c-alert (wrap Alert))
(def c-alert-group (wrap AlertGroup))
(def c-alert-action-link (wrap AlertActionLink))
(def c-alert-action-close-button (wrap AlertActionCloseButton))


(def c-modal
  (wrap Modal
    (fn [props]
      (update? props :actions
        #(clj->js
           (map-indexed
             (fn [index action]
               (uix/as-element
                 (with-meta action {:key index}))) %))))))

(def c-modal-box-body (wrap ModalBoxBody))

(def c-file-upload (wrap FileUpload))
(def c-file-upload-field (wrap FileUploadField))


(def c-dropdown
  (wrap Dropdown
    (fn [props]
      (update? props :dropdown-items
        #(clj->js
           (map-indexed
             (fn [index item]
               (uix/as-element
                 (with-meta item {:key index}))) %))))))

(def c-dropdown-item
  (wrap DropdownItem
    #(update? % :on-click
       (fn [original]
         (fn [event]
           (original event))))))

(def c-dropdown-group (wrap DropdownGroup))

(def c-kebab-toggle (wrap KebabToggle))
(def c-dropdown-toggle (wrap DropdownToggle))
(def c-dropdown-toggle-checkbox (wrap DropdownToggleCheckbox))
(def c-dropdown-toggle-action (wrap DropdownToggleAction))
(def c-bars-icon (wrap BarsIcon))
(def c-search-icon (wrap SearchIcon))
(def c-times-icon (wrap TimesIcon))
(def c-check-icon (wrap CheckIcon))
(def c-info-icon (wrap InfoIcon))

(defn c-dropdown-menu' [{:keys [toggle dropdown-items] :as props} children]
  (let
    [key (uix/memo gensym)
     open?
     (ps/sub-reducer-map! false
       {::c-dropdown-open
        (fn [_ open? key']
          (if (= key key')
            open?
            false))})]
    [:div {:on-click #(.stopPropagation %)}
     (into
       [c-dropdown
        (merge props
          {:menu-append-to js/document.body
           :dropdown-items (filter some? dropdown-items)
           :position :right
           :is-flip-enabled true
           :toggle
           [(if toggle c-dropdown-toggle c-kebab-toggle)
            (merge
              {:is-plain true
               :is-open @open?
               :on-toggle
               (fn [x e]
                 (.stopPropagation e)
                 (ps/pub! [::c-dropdown-open x key]))}
              (when-let [icon (:icon toggle)]
                {:icon icon
                 :toggle-indicator (:indicator toggle)}))]
           :is-open @open?
           :on-select
           (fn [_]
             (ps/pub! [::c-dropdown-open (not open?) key]))})]
       children)]))

(defn c-dropdown-menu [first & rest]
  (if (map? first)
    (c-dropdown-menu' first rest)
    (c-dropdown-menu' {} (conj rest first))))

(def c-dropdown-separator (wrap DropdownSeparator))

(def c-form-select (wrap FormSelect))
(def c-form-select-option (wrap FormSelectOption))

(def c-select (wrap Select))

(defn c-select-option [{{:keys [render-fn]} :value :as props}]
  (into
    [:> ^js SelectOption
     (-> props
       (update :value dissoc :render-fn)
       (update? :value clj->js))]
    (when render-fn
      (render-fn props))))

(def c-select-group (wrap SelectGroup))

(defn- ->camelCase' [value]
  (get
    {:flex-1 "flex_1"
     :flex-2 "flex_2"
     :flex-3 "flex_3"
     :flex-4 "flex_4"
     :aria-invalid "aria-invalid"}
    value
    (csk/->camelCase value)))

(defn- ->flex-property [value]
  (when value
    (if (map? value)
      (e/map-vals ->camelCase' value)
      {:default
       (->camelCase' value)})))

(def l-flex
  (wrap Flex
    (fn [props]
      (reduce
        (fn [props prop]
          (update? props prop ->flex-property))
        props
        [:spacer :grow :shrink :flex :direction
         :align-items :align-content :justify-content :align-self :align
         :display :full-width :flex-wrap :order :space-items]))))

(def l-flex-item
  (wrap FlexItem
    (fn [props]
      (reduce
        (fn [props prop]
          (update? props prop ->flex-property))
        props
        [:spacer :grow :shrink :flex :align-self :align :full-width]))))

(def c-chip (wrap Chip))
(def c-chip-group (wrap ChipGroup))

(def c-card (wrap Card))
(def c-card-header (wrap CardHeader))
(def c-card-footer (wrap CardFooter))
(def c-card-title (wrap CardTitle))
(def c-card-body (wrap CardBody))
(def c-card-header-main (wrap CardHeaderMain))
(def c-card-actions (wrap CardActions))
(def c-card-expandable-content (wrap CardExpandableContent))

(def c-tooltip (wrap Tooltip))

(def c-backdrop (wrap Backdrop))

(def c-checkbox (wrap Checkbox))
(defn c-checkbox-with-highlight [{:keys [on-change] :as props}]
  [:div.ncr-c-checkbox-with-highlight
   {:on-click on-change}
   [c-checkbox
    (assoc props :on-change (fn [_ e] (on-change e)))]])

(def c-about-modal (wrap AboutModal))

(def c-text-content (wrap TextContent))
(def c-text (wrap Text))
(def c-text-list (wrap TextList))
(def c-text-list-item (wrap TextListItem))

(def c-drawer (wrap Drawer))
(def c-drawer-content (wrap DrawerContent))
(def c-drawer-panel-content (wrap DrawerPanelContent))
(def c-drawer-content-body (wrap DrawerContentBody))
(def c-drawer-panel-body (wrap DrawerPanelBody))
(def c-drawer-section (wrap DrawerSection))
(def c-drawer-head (wrap DrawerHead))
(def c-drawer-actions (wrap DrawerActions))
(def c-drawer-close-button (wrap DrawerCloseButton))

(def c-input-group (wrap InputGroup))
(def c-input-group-text (wrap InputGroupText))

(def c-date-picker (wrap DatePicker))

(def c-popover (wrap Popover))

(def c-calendar-month (wrap CalendarMonth))

(def c-avatar (wrap Avatar))

(def c-menu (wrap Menu))
(def c-menu-content (wrap MenuContent))
(def c-menu-list (wrap MenuList))
(def c-menu-item (wrap MenuItem))
(def c-menu-group (wrap MenuGroup))

(def c-panel (wrap Panel))
(def c-panel-main (wrap PanelMain))
(def c-panel-main-body (wrap PanelMainBody))
(def c-panel-header (wrap PanelHeader))
(def c-panel-footer (wrap PanelFooter))

(def c-code-block (wrap CodeBlock))
(def c-code-block-action (wrap CodeBlockAction))
(def c-code-block-code (wrap CodeBlockCode))

(def c-clipboard-copy-button (wrap ClipboardCopyButton))

(def c-description-list (wrap DescriptionList))
(def c-description-list-group (wrap DescriptionListGroup))
(def c-description-list-term (wrap DescriptionListTerm))
(def c-description-list-description (wrap DescriptionListDescription))

(def c-markdown* (wrap ReactMarkdown))
(defn c-markdown [md-str]
  [c-markdown* {:remark-plugins (clj->js [remarkGfm])} md-str])

(def c-grid (wrap Grid))
(def c-grid-item (wrap GridItem))

(def c-badge (wrap Badge))

(def c-truncate (wrap Truncate))


(def c-ocr-file
  (wrap
    (createIcon
      #js {:name "ocr-file-icon" :xOffset 0 :yOffset 0 :width 300 :height 312
           :svgPath "m264.3 171.7-248.6 0c-8.4 0-15.7-6.7-15.7-15.7 0-8.4 6.7-15.7 15.7-15.7l248.6 0c8.4 0 15.7 6.7 15.7 15.7 0 8.4-6.7 15.7-15.7 15.7zm-20.2-113.7-53.2-53.2c-2.8-2.8-6.7-4.5-11.2-4.5l-117.6 0c-17.4 0-31.4 14-31.4 31.4l0 108.6 31.4 0 0-100.8c0-4.5 3.4-7.8 7.8-7.8l77.8 0 0 42c0 15.7 12.3 28 28 28l42 0 0 38.6 31.4 0 0-71.1c-.6-4.5-1.7-8.4-5-11.2l0 0zm-65.5 12.3 0-33.6 33.6 33.6-33.6 0zm39.2 202.2c0 4.5-3.4 7.8-7.8 7.8l-140 0c-4.5 0-7.8-3.4-7.8-7.8l0-54.3c0-8.4-6.7-15.7-15.7-15.7-8.4 0-15.7 6.7-15.7 15.7l0 62.2c0 17.4 14 31.4 31.4 31.4l155.7 0c17.4 0 31.4-14 31.4-31.4l0-62.2c0-8.4-6.7-15.7-15.7-15.7-8.4 0-15.7 6.7-15.7 15.7l0 54.3-.1 0zm-39.6-31-76.6 0c-9.2 0-16-7-16-16 0-9.2 7-16 16-16l76.6 0c9.2 0 16 7 16 16 0 9.2-8 16-16 16z"}))) 0

(def c-autocomplete-input (wrap ReactAutocompleteInput))

(def c-form-helper-text (wrap FormHelperText))
(def c-helper-text (wrap HelperText))
(def c-helper-text-item (wrap HelperTextItem))

(defn class-name [name-or-names]
  (if (vector? name-or-names)
    (->> name-or-names (filter some?) (map name) (interpose " ") (apply str))
    (name name-or-names)))

